import React, { useState, useEffect } from "react";
import footrbg from "../assets/images/footer-bg.jpg";
import logo from "../assets/images/logo.svg";
import play from "../assets/images/google-play.svg";
import app from "../assets/images/app-store.svg";
import { CiHeart, CiHome, CiShoppingCart, CiUser } from "react-icons/ci";

import footercard from "../assets/images/footer-card.png";
import {
  FaChevronDown,
  FaChevronUp,
  FaFacebookF,
  FaHeart,
  FaHome,
  FaInstagram,
  FaLinkedinIn,
  FaRegUserCircle,
  FaShoppingCart,
  FaUser,
  FaYoutube,
} from "react-icons/fa";
import { RiHome2Line, RiShoppingCart2Line, RiTwitterXFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import Config from "../API/Config";
import { MdRestaurantMenu } from "react-icons/md";
import { useCart } from '../context/CartContext';


const Footer = () => {
  const IsLogin = Config.getUserIsLogin();
  const { cartCount, refreshCartCount } = useCart();
  const [expanded, setExpanded] = useState({
    company: false,
    account: false,
    usefulLinks: false,
    socialLinks: false,
  });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    refreshCartCount();
  }, [IsLogin, refreshCartCount]);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // mobile if < md
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleAccordion = (section) => {
    if (isMobile) {
      setExpanded((prev) => ({
        ...prev,
        [section]: !prev[section],
      }));
    }
  };

  const isExpanded = (section) => {
    return isMobile ? expanded[section] : true;
  };
  const UserName = Config.getUserName();

  return (
    <>
      {/* Main Footer */}
      <footer
        style={{ backgroundImage: `url(${footrbg})` }}
        className="footer-section md:pt-20 py-10 pb-10 bg-gray-900 text-white bg-cover bg-center mb-14 md:mb-0"
      >
        <div className="container mx-auto md:px-20 px-5">
          {/* Logo */}
          <div className="flex justify-start mb-12">
            <Link to={"/"}>
              <img src={logo} alt="Rotiey Logo" className="h-14" />
            </Link>
          </div>

          {/* Main Footer Links */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 border-b border-gray-600 pb-14">
            {/* Company */}
            <div>
              <button
                className={`w-full text-left font-bold md:text-xl mb-4 border-l-2 border-theme px-2 flex justify-between items-center ${!isMobile && "cursor-default"
                  }`}
                onClick={() => toggleAccordion("company")}
              >
                Company
                {isMobile && (
                  <span>
                    {isExpanded("company") ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                )}
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${isExpanded("company") ? "max-h-[500px]" : "max-h-0"
                  }`}
              >
                <ul className="space-y-4">
                  <li>
                    <Link
                      to={'/about'}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      About us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/contact-us'}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      Contact us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/support'}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      Help & Support
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/menu'}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      Menu
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Account */}
            <div>
              <button
                className={`w-full text-left font-bold md:text-xl mb-4 border-l-2 border-theme px-2 flex justify-between items-center ${!isMobile && "cursor-default"
                  }`}
                onClick={() => toggleAccordion("account")}
              >
                Account
                {isMobile && (
                  <span>
                    {isExpanded("account") ? <FaChevronUp /> : <FaChevronDown />}
                  </span>
                )}
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${isExpanded("account") ? "max-h-[500px]" : "max-h-0"
                  }`}
              >
                <ul className="space-y-4">
                  <li>
                    <Link
                      to={IsLogin ? `/profile` : `/sign-in`}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      Profile
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={IsLogin ? `/my-order` : `/login`}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      My orders
                    </Link>
                  </li>
                  {/* <li>
                    <Link
                      to={'/wishlist'}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      Wishlist
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to={IsLogin ? `/cart` : `/sign-in`}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      Cart
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={IsLogin ? `/my-address` : `/login`}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      My Address
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Useful Links */}
            <div>
              <button
                className={`w-full text-left font-bold md:text-xl mb-4 border-l-2 border-theme px-2 flex justify-between items-center ${!isMobile && "cursor-default"
                  }`}
                onClick={() => toggleAccordion("usefulLinks")}
              >
                Useful Links
                {isMobile && (
                  <span>
                    {isExpanded("usefulLinks") ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}
                  </span>
                )}
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${isExpanded("usefulLinks") ? "max-h-[500px]" : "max-h-0"
                  }`}
              >
                <ul className="space-y-4">
                  <li>
                    <Link
                      to={'/blog'}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      Blogs
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={'/faq'}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      Faq
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={IsLogin ? `/profile` : `/sign-in`}
                      className="text-[#fff9] md:text-lg text-sm hover:text-theme font-medium hover:ml-2 transition-all duration-500"
                    >
                      {IsLogin ? "Profile" : "Sign In"}
                    </Link>
                  </li>

                </ul>
              </div>
            </div>

            {/* Social Links */}
            <div>
              <button
                className={`w-full text-left font-bold md:text-xl mb-4 border-l-2 border-theme px-2 flex justify-between items-center ${!isMobile && "cursor-default"
                  }`}
                onClick={() => toggleAccordion("socialLinks")}
              >
                Social Links
                {isMobile && (
                  <span>
                    {isExpanded("socialLinks") ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}
                  </span>
                )}
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${isExpanded("socialLinks") ? "max-h-[500px]" : "max-h-0"
                  }`}
              >
                <ul className="space-y-2">
                  <li className="flex space-x-4 mb-6">
                    <a
                      href="https://www.facebook.com/"
                      className="text-white rounded-full bg-[#0003] w-8 h-8 hover:text-theme flex justify-center items-center"
                    >
                      <FaFacebookF />
                    </a>
                    <a
                      href="https://twitter.com/"
                      className="text-white rounded-full bg-[#0003] w-8 h-8 hover:text-theme flex justify-center items-center"
                    >
                      <RiTwitterXFill />
                    </a>
                    <a
                      href="https://www.linkedin.com/"
                      className="text-white rounded-full bg-[#0003] w-8 h-8 hover:text-theme flex justify-center items-center"
                    >
                      <FaLinkedinIn />
                    </a>
                    <a
                      href="https://www.instagram.com/"
                      className="text-white rounded-full bg-[#0003] w-8 h-8 hover:text-theme flex justify-center items-center"
                    >
                      <FaInstagram />
                    </a>
                    <a
                      href="https://www.youtube.com/"
                      className="text-white rounded-full bg-[#0003] w-8 h-8 hover:text-theme flex justify-center items-center"
                    >
                      <FaYoutube />
                    </a>
                  </li>
                  <li className="flex flex-col gap-2 mt-5">
                    <a href="#" target="_blank" className="mb-4">
                      <img src={app} alt="App Store" />
                    </a>
                    <a href="#" target="_blank">
                      <img src={play} alt="Google Play" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom Footer */}
          <div className="bottom-footer-part mt-6 text-center md:text-left">
            <div className="grid md:grid-cols-1 lg:grid-cols-2 grid-cols-1 gap-2 my-auto">
              <p className="text-white text-center lg:text-start mb-3 lg:mb-0 my-auto">
                © Copyright {new Date().getFullYear()} Rotiey. All rights Reserved.
              </p>
              <img src={footercard} alt="Payment Cards" className="w-full" />
            </div>
          </div>
        </div>
      </footer>

      {/* Mobile Menu (Only on Mobile) */}
      <div className="fixed bottom-0 left-0 right-0 bg-white text-[#3d3d3d] md:hidden shadow-lg z-30 border-t border-gray-200">
        <ul className="flex justify-around">
          <li>
            <Link to={'/'} className="flex flex-col items-center py-2 px-3">
              <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mb-1 hover:bg-theme2 hover:text-white transition-colors">
                <FaHome className="text-lg" />
              </div>
              <span className="text-xs font-medium">Home</span>
            </Link>
          </li>
          <li>
            <Link to={'/menu'} className="flex flex-col items-center py-2 px-3">
              <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mb-1 hover:bg-theme2 hover:text-white transition-colors">
                <MdRestaurantMenu className="text-lg" />
              </div>
              <span className="text-xs font-medium">Menu</span>
            </Link>
          </li>
          <li>
            <Link to={IsLogin ? `/cart` : `/sign-in`} className="flex flex-col items-center py-2 px-3 relative">
              <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mb-1 hover:bg-theme2 hover:text-white transition-colors relative">
                <FaShoppingCart className="text-lg" />
                {IsLogin && cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs px-1 rounded-full min-w-[16px] h-[16px] flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </div>
              <span className="text-xs font-medium">Cart</span>
            </Link>
          </li>
          <li>
            <Link to={IsLogin ? `/profile` : `/sign-in`} className="flex flex-col items-center py-2 px-3">
              <div className="w-10 h-10 rounded-full bg-theme2 text-white flex items-center justify-center mb-1 shadow-md">
                {Config.getUserName() ? Config.getUserName().charAt(0).toUpperCase() : <FaRegUserCircle className="text-lg" />}
              </div>
              <span className="text-xs font-medium">Profile</span>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Footer;
